import RibbonGroup from './RibbonGroup';

export default RibbonGroup;